// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/rfi_questions.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { Artifact } from "./artifacts_pb";
/**
 * @generated from message mono.datagateway.v1.RfiQuestionSource
 */ export class RfiQuestionSource extends Message {
    static fromBinary(bytes, options) {
        return new RfiQuestionSource().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiQuestionSource().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiQuestionSource().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiQuestionSource, a, b);
    }
    constructor(data){
        super(), /**
   * Exact quotation, immutable even when a reviewer corrects the interpretation.
   *
   * @generated from field: string original_text = 1;
   */ _define_property(this, "originalText", ""), /**
   * Manual entries may identify an unlinked document in free text.
   *
   * @generated from field: string document_reference = 2;
   */ _define_property(this, "documentReference", ""), /**
   * @generated from field: string artifact_id = 3;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: int32 artifact_version = 4;
   */ _define_property(this, "artifactVersion", 0), /**
   * @generated from field: string sha256 = 5;
   */ _define_property(this, "sha256", ""), /**
   * 1-based page; 0 means unavailable. Empty section/paragraph means unknown.
   *
   * @generated from field: int32 page = 6;
   */ _define_property(this, "page", 0), /**
   * @generated from field: string section = 7;
   */ _define_property(this, "section", ""), /**
   * @generated from field: string paragraph = 8;
   */ _define_property(this, "paragraph", ""), /**
   * Original provider citations and verification evidence, preserved verbatim.
   *
   * @generated from field: string evidence_json = 9;
   */ _define_property(this, "evidenceJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiQuestionSource, "runtime", proto3);
_define_property(RfiQuestionSource, "typeName", "mono.datagateway.v1.RfiQuestionSource");
_define_property(RfiQuestionSource, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "original_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "document_reference",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "artifact_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "page",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "section",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "paragraph",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "evidence_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RfiQuestionSuggestion
 */ export class RfiQuestionSuggestion extends Message {
    static fromBinary(bytes, options) {
        return new RfiQuestionSuggestion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiQuestionSuggestion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiQuestionSuggestion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiQuestionSuggestion, a, b);
    }
    constructor(data){
        super(), /**
   * government_question | submission_instruction | requested_attachment |
   * page_limit | word_limit | format_limit
   *
   * @generated from field: string item_type = 1;
   */ _define_property(this, "itemType", ""), /**
   * @generated from field: string interpretation = 2;
   */ _define_property(this, "interpretation", ""), /**
   * required | optional | unknown, independent of answer and extraction state.
   *
   * @generated from field: string optionality = 3;
   */ _define_property(this, "optionality", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiQuestionSuggestion, "runtime", proto3);
_define_property(RfiQuestionSuggestion, "typeName", "mono.datagateway.v1.RfiQuestionSuggestion");
_define_property(RfiQuestionSuggestion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "item_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "interpretation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "optionality",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RfiQuestion
 */ export class RfiQuestion extends Message {
    static fromBinary(bytes, options) {
        return new RfiQuestion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiQuestion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiQuestion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiQuestion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: mono.datagateway.v1.RfiQuestionSource source = 2;
   */ _define_property(this, "source", void 0), /**
   * @generated from field: mono.datagateway.v1.RfiQuestionSuggestion suggestion = 3;
   */ _define_property(this, "suggestion", void 0), /**
   * @generated from field: bool reviewed = 4;
   */ _define_property(this, "reviewed", false), /**
   * unanswered | in_progress | answered
   *
   * @generated from field: string answer_state = 5;
   */ _define_property(this, "answerState", ""), /**
   * @generated from field: repeated string section_ids = 6;
   */ _define_property(this, "sectionIds", []), /**
   * @generated from field: bool stale = 7;
   */ _define_property(this, "stale", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiQuestion, "runtime", proto3);
_define_property(RfiQuestion, "typeName", "mono.datagateway.v1.RfiQuestion");
_define_property(RfiQuestion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "source",
            kind: "message",
            T: RfiQuestionSource
        },
        {
            no: 3,
            name: "suggestion",
            kind: "message",
            T: RfiQuestionSuggestion
        },
        {
            no: 4,
            name: "reviewed",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "answer_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "section_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 7,
            name: "stale",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RfiQuestionEvent
 */ export class RfiQuestionEvent extends Message {
    static fromBinary(bytes, options) {
        return new RfiQuestionEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiQuestionEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiQuestionEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiQuestionEvent, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string question_id = 2;
   */ _define_property(this, "questionId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: string before_json = 4;
   */ _define_property(this, "beforeJson", ""), /**
   * @generated from field: string after_json = 5;
   */ _define_property(this, "afterJson", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiQuestionEvent, "runtime", proto3);
_define_property(RfiQuestionEvent, "typeName", "mono.datagateway.v1.RfiQuestionEvent");
_define_property(RfiQuestionEvent, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "before_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "after_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RfiExtraction
 */ export class RfiExtraction extends Message {
    static fromBinary(bytes, options) {
        return new RfiExtraction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiExtraction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiExtraction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiExtraction, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string artifact_id = 2;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: int32 artifact_version = 3;
   */ _define_property(this, "artifactVersion", 0), /**
   * unavailable | failed | partial | complete. stale is calculated independently.
   *
   * @generated from field: string state = 4;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string error = 5;
   */ _define_property(this, "error", ""), /**
   * @generated from field: string raw_json = 6;
   */ _define_property(this, "rawJson", ""), /**
   * @generated from field: bool stale = 7;
   */ _define_property(this, "stale", false), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiExtraction, "runtime", proto3);
_define_property(RfiExtraction, "typeName", "mono.datagateway.v1.RfiExtraction");
_define_property(RfiExtraction, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "artifact_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "error",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "raw_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "stale",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRfiQuestionsRequest
 */ export class ListRfiQuestionsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiQuestionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiQuestionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiQuestionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiQuestionsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiQuestionsRequest, "runtime", proto3);
_define_property(ListRfiQuestionsRequest, "typeName", "mono.datagateway.v1.ListRfiQuestionsRequest");
_define_property(ListRfiQuestionsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListRfiQuestionsResponse
 */ export class ListRfiQuestionsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListRfiQuestionsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListRfiQuestionsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListRfiQuestionsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListRfiQuestionsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.RfiQuestion questions = 1;
   */ _define_property(this, "questions", []), /**
   * @generated from field: repeated mono.datagateway.v1.RfiQuestionEvent events = 2;
   */ _define_property(this, "events", []), /**
   * @generated from field: repeated mono.datagateway.v1.RfiExtraction extractions = 3;
   */ _define_property(this, "extractions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListRfiQuestionsResponse, "runtime", proto3);
_define_property(ListRfiQuestionsResponse, "typeName", "mono.datagateway.v1.ListRfiQuestionsResponse");
_define_property(ListRfiQuestionsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "questions",
            kind: "message",
            T: RfiQuestion,
            repeated: true
        },
        {
            no: 2,
            name: "events",
            kind: "message",
            T: RfiQuestionEvent,
            repeated: true
        },
        {
            no: 3,
            name: "extractions",
            kind: "message",
            T: RfiExtraction,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateRfiQuestionRequest
 */ export class CreateRfiQuestionRequest extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiQuestionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiQuestionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiQuestionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiQuestionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: mono.datagateway.v1.RfiQuestionSource source = 4;
   */ _define_property(this, "source", void 0), /**
   * @generated from field: mono.datagateway.v1.RfiQuestionSuggestion suggestion = 5;
   */ _define_property(this, "suggestion", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiQuestionRequest, "runtime", proto3);
_define_property(CreateRfiQuestionRequest, "typeName", "mono.datagateway.v1.CreateRfiQuestionRequest");
_define_property(CreateRfiQuestionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source",
            kind: "message",
            T: RfiQuestionSource
        },
        {
            no: 5,
            name: "suggestion",
            kind: "message",
            T: RfiQuestionSuggestion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.CreateRfiQuestionResponse
 */ export class CreateRfiQuestionResponse extends Message {
    static fromBinary(bytes, options) {
        return new CreateRfiQuestionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreateRfiQuestionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreateRfiQuestionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreateRfiQuestionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiQuestion question = 1;
   */ _define_property(this, "question", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(CreateRfiQuestionResponse, "runtime", proto3);
_define_property(CreateRfiQuestionResponse, "typeName", "mono.datagateway.v1.CreateRfiQuestionResponse");
_define_property(CreateRfiQuestionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "question",
            kind: "message",
            T: RfiQuestion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReviewRfiQuestionRequest
 */ export class ReviewRfiQuestionRequest extends Message {
    static fromBinary(bytes, options) {
        return new ReviewRfiQuestionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewRfiQuestionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewRfiQuestionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewRfiQuestionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: string question_id = 4;
   */ _define_property(this, "questionId", ""), /**
   * @generated from field: mono.datagateway.v1.RfiQuestionSuggestion suggestion = 5;
   */ _define_property(this, "suggestion", void 0), /**
   * @generated from field: string answer_state = 6;
   */ _define_property(this, "answerState", ""), /**
   * Full replacement of active mappings; old rows/history are retained.
   *
   * @generated from field: repeated string section_ids = 7;
   */ _define_property(this, "sectionIds", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewRfiQuestionRequest, "runtime", proto3);
_define_property(ReviewRfiQuestionRequest, "typeName", "mono.datagateway.v1.ReviewRfiQuestionRequest");
_define_property(ReviewRfiQuestionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "suggestion",
            kind: "message",
            T: RfiQuestionSuggestion
        },
        {
            no: 6,
            name: "answer_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "section_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ReviewRfiQuestionResponse
 */ export class ReviewRfiQuestionResponse extends Message {
    static fromBinary(bytes, options) {
        return new ReviewRfiQuestionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ReviewRfiQuestionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ReviewRfiQuestionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ReviewRfiQuestionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiQuestion question = 1;
   */ _define_property(this, "question", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ReviewRfiQuestionResponse, "runtime", proto3);
_define_property(ReviewRfiQuestionResponse, "typeName", "mono.datagateway.v1.ReviewRfiQuestionResponse");
_define_property(ReviewRfiQuestionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "question",
            kind: "message",
            T: RfiQuestion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRfiQuestionSourceRequest
 */ export class GetRfiQuestionSourceRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiQuestionSourceRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiQuestionSourceRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiQuestionSourceRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiQuestionSourceRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string artifact_id = 3;
   */ _define_property(this, "artifactId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiQuestionSourceRequest, "runtime", proto3);
_define_property(GetRfiQuestionSourceRequest, "typeName", "mono.datagateway.v1.GetRfiQuestionSourceRequest");
_define_property(GetRfiQuestionSourceRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetRfiQuestionSourceResponse
 */ export class GetRfiQuestionSourceResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetRfiQuestionSourceResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetRfiQuestionSourceResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetRfiQuestionSourceResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetRfiQuestionSourceResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.Artifact artifact = 1;
   */ _define_property(this, "artifact", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetRfiQuestionSourceResponse, "runtime", proto3);
_define_property(GetRfiQuestionSourceResponse, "typeName", "mono.datagateway.v1.GetRfiQuestionSourceResponse");
_define_property(GetRfiQuestionSourceResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "artifact",
            kind: "message",
            T: Artifact
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RfiExtractedQuestion
 */ export class RfiExtractedQuestion extends Message {
    static fromBinary(bytes, options) {
        return new RfiExtractedQuestion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RfiExtractedQuestion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RfiExtractedQuestion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RfiExtractedQuestion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiQuestionSource source = 1;
   */ _define_property(this, "source", void 0), /**
   * @generated from field: mono.datagateway.v1.RfiQuestionSuggestion suggestion = 2;
   */ _define_property(this, "suggestion", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RfiExtractedQuestion, "runtime", proto3);
_define_property(RfiExtractedQuestion, "typeName", "mono.datagateway.v1.RfiExtractedQuestion");
_define_property(RfiExtractedQuestion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "source",
            kind: "message",
            T: RfiQuestionSource
        },
        {
            no: 2,
            name: "suggestion",
            kind: "message",
            T: RfiQuestionSuggestion
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordRfiExtractionRequest
 */ export class RecordRfiExtractionRequest extends Message {
    static fromBinary(bytes, options) {
        return new RecordRfiExtractionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordRfiExtractionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordRfiExtractionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordRfiExtractionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string rfi_response_project_id = 2;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string actor = 3;
   */ _define_property(this, "actor", ""), /**
   * @generated from field: string artifact_id = 4;
   */ _define_property(this, "artifactId", ""), /**
   * @generated from field: int32 artifact_version = 5;
   */ _define_property(this, "artifactVersion", 0), /**
   * @generated from field: string sha256 = 6;
   */ _define_property(this, "sha256", ""), /**
   * @generated from field: string state = 7;
   */ _define_property(this, "state", ""), /**
   * @generated from field: string error = 8;
   */ _define_property(this, "error", ""), /**
   * @generated from field: string raw_json = 9;
   */ _define_property(this, "rawJson", ""), /**
   * @generated from field: repeated mono.datagateway.v1.RfiExtractedQuestion questions = 10;
   */ _define_property(this, "questions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordRfiExtractionRequest, "runtime", proto3);
_define_property(RecordRfiExtractionRequest, "typeName", "mono.datagateway.v1.RecordRfiExtractionRequest");
_define_property(RecordRfiExtractionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "artifact_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "artifact_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 6,
            name: "sha256",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "error",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "raw_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "questions",
            kind: "message",
            T: RfiExtractedQuestion,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.RecordRfiExtractionResponse
 */ export class RecordRfiExtractionResponse extends Message {
    static fromBinary(bytes, options) {
        return new RecordRfiExtractionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecordRfiExtractionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecordRfiExtractionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecordRfiExtractionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiExtraction extraction = 1;
   */ _define_property(this, "extraction", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RecordRfiExtractionResponse, "runtime", proto3);
_define_property(RecordRfiExtractionResponse, "typeName", "mono.datagateway.v1.RecordRfiExtractionResponse");
_define_property(RecordRfiExtractionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "extraction",
            kind: "message",
            T: RfiExtraction
        }
    ]));
/**
 * Sets one link idempotently without changing interpretation, review or answer state.
 *
 * @generated from message mono.datagateway.v1.SetRfiQuestionMappingRequest
 */ export class SetRfiQuestionMappingRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetRfiQuestionMappingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetRfiQuestionMappingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetRfiQuestionMappingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetRfiQuestionMappingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string rfi_response_project_id = 1;
   */ _define_property(this, "rfiResponseProjectId", ""), /**
   * @generated from field: string question_id = 2;
   */ _define_property(this, "questionId", ""), /**
   * @generated from field: string section_id = 3;
   */ _define_property(this, "sectionId", ""), /**
   * @generated from field: bool mapped = 4;
   */ _define_property(this, "mapped", false), /**
   * @generated from field: string tenant_id = 5;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string actor = 6;
   */ _define_property(this, "actor", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetRfiQuestionMappingRequest, "runtime", proto3);
_define_property(SetRfiQuestionMappingRequest, "typeName", "mono.datagateway.v1.SetRfiQuestionMappingRequest");
_define_property(SetRfiQuestionMappingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rfi_response_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "question_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "section_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "mapped",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 5,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "actor",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SetRfiQuestionMappingResponse
 */ export class SetRfiQuestionMappingResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetRfiQuestionMappingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetRfiQuestionMappingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetRfiQuestionMappingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetRfiQuestionMappingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.RfiQuestion question = 1;
   */ _define_property(this, "question", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetRfiQuestionMappingResponse, "runtime", proto3);
_define_property(SetRfiQuestionMappingResponse, "typeName", "mono.datagateway.v1.SetRfiQuestionMappingResponse");
_define_property(SetRfiQuestionMappingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "question",
            kind: "message",
            T: RfiQuestion
        }
    ]));
